import { useState } from "react";
const unflatten = require("unflatten");

const useForm = () => {
  const [refs, setRefs] = useState({});
  const [errorRefs, setErrorRefs] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  /* Ref functions */
  const getRef = (id) => {
    if (refs[id]) {
      return refs[id];
    }
  };

  const resetRefValue = (id) => {
    if (refs[id]) {
      refs[id].current.reset();
    }
  };

  const setRefValue = (id, value) => {
    if (refs[id]) {
      refs[id].current.setValue(value);
    }
  };

  const getRefValue = (id) => {
    if (refs[id]) {
      return refs[id].current.value;
    }
  };

  /* Form functions */
const register = (id, ref) => {
  setRefs((prevRefs) => {
    const newRefs = { ...prevRefs, [id]: ref };
    const error = ref?.current?.error ?? null;
    updateValidity(id, error);

    return newRefs;
  });
};
  
  const deregister = (id) => {
    setRefs((prevRefs) => {
      const { [id]: _, ...newRefs } = prevRefs;
      updateValidity(id, null);
      return newRefs;
    });
  };

  const displayErrors = () => {
    for (const id in refs) {
      const ref = refs[id]?.current;

      if (ref?.validate) {
        ref.validate();
      }

      ref?.setDisplayError(true);
    }
  };

  const getValues = () => {
    const values = {};
    for (const i in refs) {
      const value = refs[i].current.value;
      const name = refs[i].current.getName();

      values[name] = value;
    }

    return values;
  };

  const isValid = () => {
    let isValid = true;
    for (const i in refs) {
      isValid = isValid && refs[i].current.isValid();
      if (!isValid) {
        break;
      }
    }
    return isValid;
  };
  
  const submit = async (sendFunction) => {
    try {
      setIsLoading(true);
      if (!isValid()) {
        //throw new Error("Form is invalid");
      }
      
      const data = getValues();
      const formattedOutput = unflatten(data);

      //console.log(formattedOutput)
      await sendFunction(formattedOutput);
      setIsLoading(false);
      setIsSubmitted(true)
    } catch (error) {
      setIsLoading(false);
      setErrorMessage(error.message);
    }
  };

  const updateValidity = (name, error) => {
    if (typeof error === 'undefined') return;
    setErrorRefs((prevErrorRefs) => {
      const hasError = !!error;
      
      if (hasError && !prevErrorRefs.includes(name)) {
        return [...prevErrorRefs, name];
      }
  
      if (!hasError && prevErrorRefs.includes(name)) {
        return prevErrorRefs.filter((n) => n !== name);
      }
  
      return prevErrorRefs;
    });
  };
  

  const abortLoading = () => {
    // TODO:
  };

  const isFormValid = errorRefs.length === 0;

  

  return {
    register,
    deregister,
    getRef,
    resetRefValue,
    displayErrors,
    setRefValue,
    getRefValue,
    getValues,
    isFormValid,
    isSubmitted,
    errorMessage,
    isLoading,
    abortLoading,
    submit,
    updateValidity,
    errorRefs,
  };
};

export default useForm;
